/**
 * Mangopay KYC Document object status.
 *
 * imported from
 * https://docs.mangopay.com/endpoints/v2.01/kyc-documents#e204_the-kyc-document-object
 */

const KycStatusEnum = Object.assign({
  CREATED: { title: 'Created', status: 'CREATED', color: 'secondary' },
  VALIDATION_ASKED: { title: 'Validation asked', status: 'VALIDATION_ASKED', color: 'primary' },
  VALIDATED: { title: 'Validated', status: 'VALIDATED', color: 'success' },
  REFUSED: { title: 'Refused', status: 'REFUSED', color: 'error' },
  OUT_OF_DATE: { title: 'Expired', status: 'OUT_OF_DATE', color: 'error' },
  NOT_STARTED: { title: 'Not started', status: 'No success ident found', color: 'secondary' },
});

Object.freeze(KycStatusEnum);

export default KycStatusEnum;



// WEBPACK FOOTER //
// ./src/enum/emoney/KycStatus.js